export const APPS_PER_PAGE = 50;